import { render, staticRenderFns } from "./my-areas.vue?vue&type=template&id=0c7ba07f&scoped=true"
import script from "./my-areas.vue?vue&type=script&lang=js"
export * from "./my-areas.vue?vue&type=script&lang=js"
import style0 from "./my-areas.vue?vue&type=style&index=0&id=0c7ba07f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ba07f",
  null
  
)

export default component.exports